/**
 * @generated SignedSource<<0e52b0990e917db8c24ff40d8dd1ec9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebShareButton_node$data = {
  readonly __typename?: string;
  readonly canonicalUrl?: URIString;
  readonly name?: string;
  readonly " $fragmentType": "WebShareButton_node";
};
export type WebShareButton_node$key = {
  readonly " $data"?: WebShareButton_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebShareButton_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebShareButton_node",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canonicalUrl",
          "storageKey": null
        }
      ],
      "type": "HasCanonicalUrlInterface",
      "abstractKey": "__isHasCanonicalUrlInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "FolderNodeInterface",
      "abstractKey": "__isFolderNodeInterface"
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Vault",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "VaultItem",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "Space",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/)
      ],
      "type": "Announcement",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};
})();

(node as any).hash = "7565221047fffa1dc38b568ae33bffdb";

export default node;
